export default {"src":"/login-app/[GIT_HASH]/_next/static/media/star_half.2dec6223.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};